export interface DashboardInfo {
  // The path that should be used for the dashboard.
  path: string;
  id: string;
  title: string;
  features?: {
    downloadPDF?: boolean;
    downloadCSV?: boolean;
  };
}
export const MARKETPLACE_DASHBOARD_NAMES: Array<DashboardInfo> = [
  { path: "payment", id: "Payment Dashboard", title: "Payment Dashboard", features: { downloadCSV: true } },
  {
    path: "roster",
    id: "Roster Generator",
    title: "Roster Dashboard",
    features: { downloadPDF: true, downloadCSV: true },
  },
];
